import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify'; // Optional for alerts

const BannerAdd = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    banner_image: null,
    banner_heading: '',
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, [field]: file }));
      if (field === 'banner_image') setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      // Prepare multipart form data
      const data = new FormData();
      data.append("banner_image", formData.banner_image);
      data.append("banner_heading", formData.banner_heading);

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_banner",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status) {
        toast.success("Banner added successfully!");
        navigate("/Banner"); // redirect back to list page
      } else {
        toast.error(response.data.message || "Failed to add brand");
      }
    } catch (error) {
      console.error("Error adding brand:", error);
      toast.error("Something went wrong while adding the brand");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Add Banner</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item"><a href="#">Banner Section</a></li>
            <li className="breadcrumb-item active">Add</li>
          </ol>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Banner Section</h4>
            </div>
            <div className="card-body row">
              <div className="col-lg-6 mb-3">
                <label className="form-label">Banner Image</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'banner_image')}
                />
                {previewImage && <img src={previewImage} alt="Preview" height="80" className="mt-2" />}
              </div>


              <div className="col-lg-6 mb-3">
                <label className="form-label">Heading</label>
                <input
                  type="text"
                  name="banner_heading"
                  value={formData.banner_heading}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Heding"
                  required
                />
              </div>
            </div>

            <div className="card-footer">
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Saving..." : "Save Global Brand"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BannerAdd;
